// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1hqwm","errorImg":"styles_errorImg__1dd5C"};